import React from 'react';
import { useLoungesByExperienceType } from '@/hooks/loungesHooks/loungesHelperHooks';
import { Lounge } from '@/types';
import { LoungeTypes } from '@/constants';
import { useCommonContent } from '@/hooks/oneCmsIntlHooks/oneCmsIntlHelperHooks';
import SearchLoungeResult from '../common/SearchLoungeResult';
import SearchLoungeResultNoCarousel from '../common/SearchLoungeResultNoCarousel';
import Loading from '../common/Loading';
import Divider from '../common/Divider';

export const CenturionNetworkLounges = () => {
  const { data, error, isLoading } =
    useLoungesByExperienceType('CENTURION,SIDECAR');
  const {
    centurionNetwork: { header, description, centurionHeader, sidecarHeader },
  } = useCommonContent();

  if (error) {
    return null;
  }

  if (isLoading) {
    return (
      <Loading
        size="lg"
        containerClassName="flex flex-justify-center dls-white-bg pad-4 margin-t"
      />
    );
  }

  const centurionLounges = data
    ?.filter(
      (lounge: Lounge) => lounge.experience_type === LoungeTypes.CENTURION
    )
    .sort((a: Lounge, b: Lounge) =>
      (a.airport?.location?.city ?? '').localeCompare(
        b.airport?.location?.city ?? ''
      )
    );
  const sidecarLounges = data
    ?.filter((lounge: Lounge) => lounge.experience_type === LoungeTypes.SIDECAR)
    .sort((a: Lounge, b: Lounge) =>
      (a.airport?.location?.city ?? '').localeCompare(
        b.airport?.location?.city ?? ''
      )
    );

  return (
    <>
      <Divider />
      <h2 className="tw-heading-md-regular tw-pb-1 tw-text-gray-900 sm_tw-pt-4">
        {header}
      </h2>
      <p className="tw-font-sans tw-text-base tw-text-gray-900">
        {description}
      </p>
      <h3 className="tw-heading-xs-bold tw-pt-6 tw-text-gray-900 sm_tw-pt-10">
        {centurionHeader}
      </h3>
      <div className="tw-relative tw-grid tw-grid-cols-2 tw-place-items-center tw-gap-4 tw-pt-4 sm_tw-gap-8 sm_tw-pt-6 lg_tw-grid-cols-3">
        {centurionLounges?.map((lounge: Lounge) => (
          <>
            <div className="tw-hidden tw-w-full sm_tw-block">
              <SearchLoungeResult
                heading={lounge.airport?.location?.city}
                description={`${lounge.airport?.iata} • ${lounge.airport?.name}`}
                lounge={lounge}
                hideLoungeStatus={true}
                hideLoungeTypeBadge={true}
                trackElement="A Worldwide Collection of Exceptional Spaces"
                trackDetail={`Centurion Lounge>>${lounge.airport?.iata}`}
              />
            </div>
            <div className="tw-block tw-w-full sm_tw-hidden">
              <SearchLoungeResultNoCarousel
                heading={lounge.airport?.location?.city}
                description={`${lounge.airport?.iata}`}
                lounge={lounge}
                hideLoungeStatus={true}
                trackElement="A Worldwide Collection of Exceptional Spaces"
                trackDetail={`Centurion Lounge>>${lounge.airport?.iata}`}
              />
            </div>
          </>
        ))}
      </div>
      <h3 className="tw-heading-xs-bold tw-pt-6 tw-text-gray-900 sm_tw-pt-10">
        {sidecarHeader}
      </h3>
      <div className="tw-relative tw-grid tw-grid-cols-2 tw-place-items-center tw-gap-4 tw-pt-4 sm_tw-gap-8 sm_tw-pt-6 lg_tw-grid-cols-3">
        {sidecarLounges?.map((lounge: Lounge) => (
          <>
            <div className="tw-hidden tw-w-full sm_tw-block">
              <SearchLoungeResult
                heading={lounge.airport?.location?.city}
                description={`${lounge.airport?.iata} • ${lounge.airport?.name}`}
                lounge={lounge}
                hideLoungeStatus={true}
                hideLoungeTypeBadge={true}
                trackElement="A Worldwide Collection of Exceptional Spaces"
                trackDetail={`Sidecar By The Centurion Lounge>>${lounge.airport?.iata}`}
              />
            </div>
            <div className="tw-block tw-w-full sm_tw-hidden">
              <SearchLoungeResultNoCarousel
                heading={lounge.airport?.location?.city}
                description={`${lounge.airport?.iata}`}
                lounge={lounge}
                hideLoungeStatus={true}
                trackElement="A Worldwide Collection of Exceptional Spaces"
                trackDetail={`Sidecar by The Centurion Lounge>>${lounge.airport?.iata}`}
              />
            </div>
          </>
        ))}
      </div>
    </>
  );
};
